import { Button } from 'antd';
import useChronometer from './useChronometer.hook';
import { StyledChronometer } from './Chronometer.styled';
import { useContext, useRef } from 'react';
import { GameLoopContext } from '@/shared/GameComponents/GameLoopContext/GameLoopContext';

export default function Chronometer({ tick, alarm }) {
  const audioRef = useRef();
  const game = useContext(GameLoopContext);
  const { state, actions } = useChronometer({
    tick,
    alarm,
    audioRef,
    game,
  });
  return (
    <StyledChronometer className="chronometer">
      <div className="elapsed-time">
        <div className="minutes">
          {timeDigits(game.state.elapsedTime.minutes)}
        </div>

        <div className="seconds">
          {timeDigits(game.state.elapsedTime.seconds)}
        </div>
        {/* <audio ref={audioRef}></audio> */}
      </div>
    </StyledChronometer>
  );
}

function timeDigits(value) {
  return value < 10 ? `0${value}` : value;
}
